export default class UserAnswers {
  constructor(allAnswers, isVisibleForUser, questionType, user) {
    this.allAnswers = allAnswers;
    this.isVisibleForUser = isVisibleForUser;
    this.questionType = questionType;
    this.user = user;
  }
}
